module.exports = __webpack_public_path__ + "static/img/a5.cb4025af.png";